// removed by extract-text-webpack-plugin
module.exports = {"block":"_2U5nf1NS2rH5LMXUX9S1xj","bg":"_2QNMy3jEbf9RTzmrIzX6ky","tall":"oTAklofnkkOkykGU_s4rg","block-content":"_1_pdZdwv6eHTAQGTUI0diw","list-content":"_21W_ZYkaPD13gQQjAyDcKx","heading":"_1Wqq9YS78MlPkNnLHfEGn7","text":"O99bYyr_QK0sYjGSBErjq","zebra":"_2_huAt1ManTdmQwhAxaKGO","yellow":"_1Gp6RDtxM9zlq4MlUJei_G","darkgray":"_15M_MqetFsw_-tap_xm-yc","video":"NvHv69fpphOZiWdoKAvl4","links":"_2OEj6Af7K6zGEa5YeLABrY","videoplayer":"NRA-9dTCT2mwmINpgqCa0","icon":"_2ZaXKPniLteMeeTJQXRJBM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkListBlock/LinkListBlock.module.scss
// module id = 783
// module chunks = 0